import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import InnerHeading from "../../Global Functions/innerHeading";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { Link, useParams, useNavigate } from "react-router-dom";
import TextInput from "../../Global Functions/textInput";
import { useDispatch, useSelector } from "react-redux";
import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";
import toast from "react-hot-toast";
import { viewReferralCommission, updateReferralCommission } from "../../Redux/Actions/referralCommissionAction";
import TwoButtons from "../../Global Functions/buttons";

const EditReferralCommission = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { referralCommission } = useSelector(
    (state) => state.referral_commission || {}
  );

  const [referralAmount, setReferralAmount] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(viewReferralCommission(id)).then((res) => {
        if (res?.data?.referral_amount !== undefined) {
          setReferralAmount(res.data.referral_amount);
        }
      });
    }
  }, [id, dispatch]);

  const handleReferralAmountChange = (e) => {
    setReferralAmount(e.target.value);
  };

  const handleUpdate = async () => {
    if (!id) {
      toast.error("Invalid referral commission ID");
      return;
    }
    if (!referralAmount || isNaN(referralAmount)) {
      toast.error("Please enter a valid referral amount");
      return;
    }
    setIsUpdating(true);
    try {
      await dispatch(updateReferralCommission({ id, referral_amount: referralAmount }));
    //   toast.success("Referral amount updated successfully!");
      dispatch(viewReferralCommission(id));
    } catch (error) {
      toast.error("Failed to update referral amount");
    } finally {
      setIsUpdating(false);
    }
  };

  const navigateToList = () => {
    navigate("/referral_commission");
  };

  return (
    <MainLayout>
      <div className="bg-white grid-span-5 radius-20 padding-20 grid-template-2 gap-10 full-screen full-height">
        <InnerHeading
          Icon={BackIcon}
          heading="Edit Referral Commission"
          buttonLabel="View Referral Commissions"
          onClick={navigateToList}
        />

        <TextInput
          label="Country"
          value={referralCommission?.data?.country?.country_name || "No Data"}
          disabled
        />
        <TextInput
          label="State"
          value={referralCommission?.data?.state?.state_name || "No Data"}
          disabled
        />
        <TextInput
          label="City"
          value={referralCommission?.data?.city?.city_name || "No Data"}
          disabled
        />
        <TextInput
          label="Unit"
          value={referralCommission?.data?.unit || "No Data"}
          disabled
        />
        <TextInput
          label="Referral Amount"
          type="number"
          value={referralAmount}
          onChange={handleReferralAmountChange}
          disabled={isUpdating}
        />
        <TextInput
          label="Status"
          value={ToFirstCapital(referralCommission?.data?.status) || "No Data"}
          disabled
        />
        <TextInput
          label="Created At"
          value={
            referralCommission?.data?.created_at
              ? DateToLocale(referralCommission.data.created_at)
              : "No Data"
          }
          disabled
        />
        <TextInput
          label="Updated At"
          value={
            referralCommission?.data?.updated_at
              ? DateToLocale(referralCommission.data.updated_at)
              : "No Data"
          }
          disabled
        />

        <div className="span2" style={{ marginTop: "20px" }}>
          <TwoButtons
            buttonHead1="Cancel"
            noUrl={true}
            LinkURL="/referral_commission"
            onClick1={navigateToList}
            buttonHead2={isUpdating ? "Updating..." : "Update"}
            onClick2={handleUpdate}
            disabled2={isUpdating}
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default EditReferralCommission;
